import React from "react";

export const AlertCircleIcon = ({ size = "14", fill = "#6D7F92" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
  >
    <g clip-path="url(#clip0_66106_7467)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.00065 1.7487C4.10116 1.7487 1.75065 4.0992 1.75065 6.9987C1.75065 9.89819 4.10116 12.2487 7.00065 12.2487C9.90015 12.2487 12.2507 9.89819 12.2507 6.9987C12.2507 4.0992 9.90015 1.7487 7.00065 1.7487ZM0.583984 6.9987C0.583984 3.45487 3.45682 0.582031 7.00065 0.582031C10.5445 0.582031 13.4173 3.45487 13.4173 6.9987C13.4173 10.5425 10.5445 13.4154 7.00065 13.4154C3.45682 13.4154 0.583984 10.5425 0.583984 6.9987Z"
        fill={fill}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.99935 4.08203C7.32152 4.08203 7.58268 4.3432 7.58268 4.66536V6.9987C7.58268 7.32086 7.32152 7.58203 6.99935 7.58203C6.67718 7.58203 6.41602 7.32086 6.41602 6.9987V4.66536C6.41602 4.3432 6.67718 4.08203 6.99935 4.08203Z"
        fill={fill}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.41602 9.33333C6.41602 9.01117 6.67718 8.75 6.99935 8.75H7.00518C7.32735 8.75 7.58852 9.01117 7.58852 9.33333C7.58852 9.6555 7.32735 9.91667 7.00518 9.91667H6.99935C6.67718 9.91667 6.41602 9.6555 6.41602 9.33333Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_66106_7467">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
